// React
import {
  Navigate,
  Outlet,
  useLocation,
  useOutletContext,
} from "react-router-dom";

// Libraries
import { useTranslation } from "react-i18next";

// Components
import PortalLoading from "Common/Components/PortalLoading";

// Auth
import { useMBSAuth } from "Auth/MBS/MBSAuthContext";

const MBSProtectedRoute = () => {
  const { t } = useTranslation();
  const { isAuthenticated, isLoading } = useMBSAuth();
  const location = useLocation();
  const outletContext = useOutletContext();

  if (isLoading) {
    return <PortalLoading message={t("common.loading")} />;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/mbs/login" replace state={{ from: location.pathname }} />
    );
  }

  return <Outlet context={outletContext} />;
};

export default MBSProtectedRoute;
